import { ChangeEvent, Dispatch, SetStateAction, useState } from 'react';
import {
    Modal,
    Button,
    MenuItem,
    Select,
    SelectChangeEvent,
    CardMedia,
    Input,
    TextField
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';

interface Props {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>
    mode: 'add' | 'edit';
}

export default function AddEditTone({ open, onClose, setOpen, mode }: Props) {

    const title = mode === 'add' ? 'Tone' : 'Tone';

    const [Category, setCategory] = React.useState('default');
    const handleCategoryChange = (event: SelectChangeEvent) => {
        setCategory(event.target.value as string);
    };
    const [alertMessage, setAlertMessage] = useState("");
    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState(0);
    const [image, setImage] = useState<string>("");
    const [fileName, setFileName] = useState<string>("");


    return (
        <Modal
            className="modal alertConfig_modal"
            open={open}
            onClose={onClose}
        >
            <div className="modal-dialog">
                <div className="modal-body">
                    <div className="modal_title">
                        <h2>{title}</h2>
                        <div className="btn-close" onClick={() => setOpen(false)}>
                            <CloseIcon />
                        </div>
                    </div>

                    <form className="form" action="">

                        <div className="control_group">
                            <label>Upload Tone</label>
                            {image ? (
                                <div className="upload_image v2 no_radius">
                                    <div className="upload_image_holder">
                                        <figure>
                                            <CardMedia
                                                component="img"
                                                image={image}
                                                alt="photo"
                                            />
                                        </figure>
                                        <CloseIcon
                                            onClick={() => {
                                                setImage("");
                                                setFileName("");
                                            }}
                                        />
                                    </div>
                                </div>
                            ) : (
                                <label
                                    className="upload_image v2 no_radius"
                                    htmlFor="icon-button-file"
                                >
                                    <Input
                                        sx={{ display: "none" }}
                                        id="icon-button-file"
                                        type="file"
                                        inputProps={{
                                            accept: "image/png,image/jpeg",
                                        }}
                                        onChange={(
                                            event: ChangeEvent<HTMLInputElement>
                                        ) => {
                                            const files = (
                                                event.target as HTMLInputElement
                                            ).files;
                                            if (
                                                files &&
                                                files[0].type.includes("image")
                                            ) {
                                                setFileName(files[0].name);
                                                setImage(URL.createObjectURL(files[0]));
                                            } else {
                                                setAlertType(0);
                                                setShowAlert(true);
                                                setAlertMessage(
                                                    "This field only accepts images."
                                                );
                                            }
                                        }}
                                    />
                                    <span className="upload_image_holder">
                                        <figure className="add_img">
                                            <span className="upload_img_icon">
                                                <img
                                                    src="/static/images/upload_icon.svg"
                                                    alt="icon"
                                                />
                                                Upload Tone
                                            </span>
                                        </figure>
                                    </span>
                                </label>
                            )}
                        </div>
                        <div className="control_group">
                            <label> Tags</label>
                            <TextField
                                fullWidth
                                hiddenLabel
                                placeholder="Enter"

                            />
                        </div>
                        <div className="footer_btn_flex">
                            <Button className="btn btn_grey" onClick={() => setOpen(false)}>Cancel</Button>
                            <Button className="btn btn_primary" onClick={() => setOpen(false)}>Submit</Button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
}
